/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getLensList = /* GraphQL */ `
  query GetLensList($id: ID!) {
    getLensList(id: $id) {
      id
      PartNum
      lens_type
      f_num
      max_fov
      distortion
      image_circle
      efl
      resolution
      url
      alpha
      beta
      ttl     
      constr
      ingress
      createdAt
      updatedAt
    }
  }
`;
export const listLensLists = /* GraphQL */ `
  query ListLensLists(
    $filter: ModelLensListFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLensLists(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        PartNum
        lens_type
        f_num
        max_fov
        distortion
        image_circle
        efl
        resolution
        url
        alpha
        beta
        ttl
        constr
        ingress
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getSensorData = /* GraphQL */ `
  query GetSensorData($id: ID!) {
    getSensorData(id: $id) {
      id
      sensorhpix
      sensorvpix
      sensormfg
      sensorpitch
      sensortype
      createdAt
      updatedAt
    }
  }
`;
export const listSensorData = /* GraphQL */ `
  query ListSensorData(
    $filter: ModelSensorDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSensorData(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        sensorhpix
        sensorvpix
        sensormfg
        sensorpitch
        sensortype
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
